import { Component, OnInit } from '@angular/core';
import { CommonModule, NgForOf } from '@angular/common';
import { ThemeService } from '../../services/theme-service';
import { CircleButtonComponent } from '../buttons/circle-button.component';
import { Router, RouterLink } from '@angular/router';
import { ListItemComponent } from '../list-item/list-item.component';
import { ConfigService } from '../../services/config.service';
import { Receipt } from '../../models/Receipt';
import { AuthorizedApiService } from '../../services/authorized-api.service';
import { AppStateService } from '../../services/app-state.service';
import MoneyUtils from '../../utils/Utils';
import { map, Observable, startWith, switchMap, take } from 'rxjs';
import { LoadingSpinnerComponent } from "../ui/loading-spinner-component";
import { SeparatorComponent } from "../ui/separator.component";
import { UrlHistoryService } from '../../services/url.history.service';
import {BaseButtonComponent} from '../buttons/base-button.component';
import {TranslateService} from '../../services/translate.service';

@Component({
  selector: 'app-receipt-list',
  standalone: true,
  imports: [
    NgForOf,
    LoadingSpinnerComponent,
    RouterLink,
    CommonModule,
    CircleButtonComponent,
    SeparatorComponent,
    BaseButtonComponent
  ],
  templateUrl: './receipt-list.component.html',
  styleUrl: './receipt-list.component.css',
})
export class ReceiptListComponent implements OnInit {

  constructor(
    private themeService: ThemeService,
    private api: AuthorizedApiService,
    private appState: AppStateService,
    private identityService: UrlHistoryService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  vm$!: Observable<{ loading: boolean; receipts: Receipt[] }>;

  ngOnInit(): void {
    this.vm$ = this.appState.observeAppState().pipe(
      take(1),
      switchMap(() =>
        this.api.getReceipts().pipe(
          map((receipts: Receipt[]) => ({
            loading: false,
            receipts
          })),
          startWith({
            loading: true,
            receipts: []
          })
        )
      )
    );
  }

  ngOnDestroy(): void {
  }

  getString(s: string) {
    return this.translate.getString(s);
  }

  back() {
    this.identityService.navigateBack();
  }

  get currencySymbol(): string {
    return MoneyUtils.symbol();
  }

  navReceipt(receipt: Receipt) {
    this.router.navigate([this.appState.venueId, "receipt", receipt.key]);
  }
}
